export const ERROR_CODES = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    CONFLICT: 'CONFLICT',
    RATE_LIMITED: 'RATE_LIMITED',
    QUOTA_EXCEEDED: 'QUOTA_EXCEEDED',
    PROVIDER_ERROR: 'PROVIDER_ERROR',
    REGISTRATION_DISABLED: 'REGISTRATION_DISABLED',
    /** Read-only maintenance mode (v0.11): a write refused with 423 Locked. */
    READ_ONLY: 'READ_ONLY',
    /**
     * The published acceptable use policy has not been accepted by this person
     * (#367): a request that uses the instance is refused with 403 until they
     * accept it (POST /api/me/onboarding/accept-policy).
     */
    POLICY_ACCEPTANCE_REQUIRED: 'POLICY_ACCEPTANCE_REQUIRED',
    /**
     * This role must use two-step verification and this session has not passed
     * one (v0.14, #399): every request outside a short allowlist (sign-out, the
     * second step, GET /api/me, /api/me/mfa/*) is refused with 403 until the
     * person sets one up or signs in with it. `details.reason` is `enrol` or
     * `second_step`, `details.deadline` the ISO time the grace ended.
     */
    MFA_ENROLMENT_REQUIRED: 'MFA_ENROLMENT_REQUIRED',
    /**
     * Saving a requirement the acting administrator could not satisfy, or one
     * naming `admin` with no enrolled local administrator (409): nobody may
     * turn on what they cannot complete.
     */
    MFA_REQUIRED_FOR_ACTOR: 'MFA_REQUIRED_FOR_ACTOR',
    /**
     * A replica shutting down (v0.11.1): a new chat turn refused with 503 and
     * Retry-After before anything is stored; send it again. Not a fault.
     */
    SERVER_RESTARTING: 'SERVER_RESTARTING',
    /**
     * Data classification (v0.14, #395): the conversation carries a data class
     * the chosen model (or, for a share link or compaction, the destination) is
     * not approved for. 403, nothing stored or sent; `details` names the missing
     * classes and the approved models (DataClassBlockedDetails).
     */
    DATA_CLASS_BLOCKED: 'DATA_CLASS_BLOCKED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
//# sourceMappingURL=errors.js.map